"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActionToBeLogged = exports.getActionNotLogged = exports.ACTION_CODE = exports.ACTION_TYPE = exports.ObjectCategory = exports.USER_TYPE = void 0;
/**
 * User type (for log)
 */
var USER_TYPE;
(function (USER_TYPE) {
    USER_TYPE["WEB"] = "WEB";
    USER_TYPE["MOBILE"] = "MOBILE";
})(USER_TYPE = exports.USER_TYPE || (exports.USER_TYPE = {}));
var ObjectCategory;
(function (ObjectCategory) {
    ObjectCategory["MOB_USER"] = "MOB_USER";
    ObjectCategory["WEB_USER"] = "WEB_USER";
    ObjectCategory["LIST"] = "LIST";
    ObjectCategory["ITEM"] = "ITEM";
    ObjectCategory["CLIENT"] = "CLIENT";
    ObjectCategory["TEAM"] = "TEAM";
    ObjectCategory["LOG"] = "LOG";
    ObjectCategory["DASHBOARD"] = "DASHBOARD";
    ObjectCategory["WORKFLOW"] = "WORKFLOW";
    ObjectCategory["SUBMISSION"] = "SUBMISSION";
    ObjectCategory["DOCUMENT"] = "DOCUMENT";
    ObjectCategory["TRANSFORMATION"] = "TRANSFORMATION";
    ObjectCategory["STREAM"] = "STREAM";
    ObjectCategory["EMAILGENERATION"] = "EMAILGENERATION";
})(ObjectCategory = exports.ObjectCategory || (exports.ObjectCategory = {}));
var ACTION_TYPE;
(function (ACTION_TYPE) {
    ACTION_TYPE["CREATE"] = "CREATE";
    ACTION_TYPE["EDIT"] = "EDIT";
    ACTION_TYPE["DELETE"] = "DELETE";
    ACTION_TYPE["ARCHIVE"] = "ARCHIVE";
    ACTION_TYPE["RESTORE"] = "RESTORE";
    ACTION_TYPE["FETCH"] = "FETCH";
    ACTION_TYPE["RUN"] = "RUN";
    // particular actions
    ACTION_TYPE["ASSIGN_MOBILE_USERS_TO"] = "ASSIGN_MOBILE_USERS_TO";
    ACTION_TYPE["ASSIGN_WEB_USERS_TO"] = "ASSIGN_WEB_USERS_TO";
    ACTION_TYPE["ASSIGN_TEAMS_TO"] = "ASSIGN_TEAMS_TO";
    ACTION_TYPE["ASSIGN"] = "ASSIGN";
    ACTION_TYPE["UNASSIGN"] = "UNASSIGN";
    ACTION_TYPE["UPLOAD_FILE_FOR"] = "UPLOAD_FILE_FOR";
    ACTION_TYPE["LICENSE"] = "LICENSE";
    ACTION_TYPE["UNLICENSE"] = "UNLICENSE";
})(ACTION_TYPE = exports.ACTION_TYPE || (exports.ACTION_TYPE = {}));
/**
 * Action code (for log)
 */
exports.ACTION_CODE = {
    // Authentication
    OTP: "OTP",
    Login: "LOGIN",
    Logout: "LOGOUT",
    PasswordRequest: "PASSWORD_REQUEST",
    ChangePassword: "CHANGE_PASSWORD",
    ResetPassword: "RESET_PASSWORD",
    // SUBMISSION
    Submit: `${ACTION_TYPE.CREATE}_${ObjectCategory.SUBMISSION}`,
    UploadFileForSubmission: `${ACTION_TYPE.UPLOAD_FILE_FOR}_${ObjectCategory.SUBMISSION}`,
    FetchSubmissions: `${ACTION_TYPE.FETCH}_${ObjectCategory.SUBMISSION}S`,
    FetchSubmission: `${ACTION_TYPE.FETCH}_${ObjectCategory.SUBMISSION}`,
    EditSubmission: `${ACTION_TYPE.EDIT}_${ObjectCategory.SUBMISSION}`,
    DeleteSubmission: `${ACTION_TYPE.DELETE}_${ObjectCategory.SUBMISSION}`,
    FetchPictures: `${ACTION_TYPE.FETCH}_PICTURES`,
    UploadFileForTaskSubmissions: `${ACTION_TYPE.UPLOAD_FILE_FOR}_TASK_SUBMISSIONS`,
    // OTP CHECK DURING WORKFLOW
    OTP_SEND: "OTP_SEND",
    OTP_VERIFICATION: "OTP_VERIFICATION",
    // item management
    FetchItems: `${ACTION_TYPE.FETCH}_${ObjectCategory.ITEM}S`,
    CreateItem: `${ACTION_TYPE.CREATE}_${ObjectCategory.ITEM}`,
    CreateItems: `${ACTION_TYPE.CREATE}_${ObjectCategory.ITEM}S`,
    DeleteItem: `${ACTION_TYPE.DELETE}_${ObjectCategory.ITEM}`,
    DeleteItems: `${ACTION_TYPE.DELETE}_${ObjectCategory.ITEM}S`,
    ArchiveItem: `${ACTION_TYPE.ARCHIVE}_${ObjectCategory.ITEM}`,
    ArchiveItems: `${ACTION_TYPE.ARCHIVE}_${ObjectCategory.ITEM}S`,
    RestoreItem: `${ACTION_TYPE.RESTORE}_${ObjectCategory.ITEM}`,
    RestoreItems: `${ACTION_TYPE.RESTORE}_${ObjectCategory.ITEM}S`,
    UpdateItem: `${ACTION_TYPE.EDIT}_${ObjectCategory.ITEM}`,
    UpdateItems: `${ACTION_TYPE.EDIT}_${ObjectCategory.ITEM}S`,
    UploadFileForItem: `${ACTION_TYPE.UPLOAD_FILE_FOR}_${ObjectCategory.ITEM}`,
    AssignTeamsToItem: `${ACTION_TYPE.ASSIGN_TEAMS_TO}_${ObjectCategory.ITEM}S`,
    AssignItems: `${ACTION_TYPE.ASSIGN}_${ObjectCategory.ITEM}S`,
    UnassignItems: `${ACTION_TYPE.UNASSIGN}_${ObjectCategory.ITEM}S`,
    // list management
    FetchLists: `${ACTION_TYPE.FETCH}_${ObjectCategory.LIST}S`,
    CreateList: `${ACTION_TYPE.CREATE}_${ObjectCategory.LIST}`,
    ArchiveList: `${ACTION_TYPE.ARCHIVE}_${ObjectCategory.LIST}`,
    RestoreList: `${ACTION_TYPE.RESTORE}_${ObjectCategory.LIST}`,
    DeleteList: `${ACTION_TYPE.DELETE}_${ObjectCategory.LIST}`,
    UpdateList: `${ACTION_TYPE.EDIT}_${ObjectCategory.LIST}`,
    FetchListIds: `${ACTION_TYPE.FETCH}_${ObjectCategory.LIST}_IDS`,
    // workflow management
    FetchWorkflows: `${ACTION_TYPE.FETCH}_${ObjectCategory.WORKFLOW}S`,
    CreateWorkflow: `${ACTION_TYPE.CREATE}_${ObjectCategory.WORKFLOW}`,
    ArchiveWorkflow: `${ACTION_TYPE.ARCHIVE}_${ObjectCategory.WORKFLOW}`,
    RestoreWorkflow: `${ACTION_TYPE.RESTORE}_${ObjectCategory.WORKFLOW}`,
    DeleteWorkflow: `${ACTION_TYPE.DELETE}_${ObjectCategory.WORKFLOW}`,
    UpdateWorkflow: `${ACTION_TYPE.EDIT}_${ObjectCategory.WORKFLOW}`,
    UploadFileForWorkflow: `${ACTION_TYPE.UPLOAD_FILE_FOR}_${ObjectCategory.WORKFLOW}`,
    FetchWorkflowVersions: `${ACTION_TYPE.FETCH}_${ObjectCategory.WORKFLOW}_VERSIONS`,
    RestoreWorkflowVersion: `${ACTION_TYPE.RESTORE}_${ObjectCategory.WORKFLOW}_VERSION`,
    // user management
    FetchMobUsers: `${ACTION_TYPE.FETCH}_${ObjectCategory.MOB_USER}S`,
    FetchWebUsers: `${ACTION_TYPE.FETCH}_${ObjectCategory.WEB_USER}S`,
    CreateMobUser: `${ACTION_TYPE.CREATE}_${ObjectCategory.MOB_USER}`,
    CreateWebUser: `${ACTION_TYPE.CREATE}_${ObjectCategory.WEB_USER}`,
    CreateMobUsers: `${ACTION_TYPE.CREATE}_${ObjectCategory.MOB_USER}S`,
    CreateWebUsers: `${ACTION_TYPE.CREATE}_${ObjectCategory.WEB_USER}S`,
    DeleteMobUser: `${ACTION_TYPE.DELETE}_${ObjectCategory.MOB_USER}`,
    DeleteWebUser: `${ACTION_TYPE.DELETE}_${ObjectCategory.WEB_USER}`,
    DeleteMobUsers: `${ACTION_TYPE.DELETE}_${ObjectCategory.MOB_USER}S`,
    DeleteWebUsers: `${ACTION_TYPE.DELETE}_${ObjectCategory.WEB_USER}S`,
    EditMobUser: `${ACTION_TYPE.EDIT}_${ObjectCategory.MOB_USER}`,
    EditMobUsers: `${ACTION_TYPE.EDIT}_${ObjectCategory.MOB_USER}S`,
    EditWebUser: `${ACTION_TYPE.EDIT}_${ObjectCategory.WEB_USER}`,
    EditWebUsers: `${ACTION_TYPE.EDIT}_${ObjectCategory.WEB_USER}S`,
    LicenseMobileUser: `${ACTION_TYPE.LICENSE}_${ObjectCategory.MOB_USER}`,
    LicenseMobileUsers: `${ACTION_TYPE.LICENSE}_${ObjectCategory.MOB_USER}S`,
    UnlicenseMobileUser: `${ACTION_TYPE.UNLICENSE}_${ObjectCategory.MOB_USER}`,
    UnlicenseMobileUsers: `${ACTION_TYPE.UNLICENSE}_${ObjectCategory.MOB_USER}S`,
    AssignMobileUsersToTeams: `${ACTION_TYPE.ASSIGN_MOBILE_USERS_TO}_${ObjectCategory.TEAM}S`,
    AssignWebUsersToTeams: `${ACTION_TYPE.ASSIGN_WEB_USERS_TO}_${ObjectCategory.TEAM}S`,
    CreateSuperAdmin: `CREATE_SUPER_ADMIN`,
    CreateDateChange: `${ACTION_TYPE.CREATE}_DATE_CHANGE`,
    UnlockLogin: `UNLOCK_LOGIN`,
    // team management
    FetchTeams: `${ACTION_TYPE.FETCH}_${ObjectCategory.TEAM}S`,
    CreateTeam: `${ACTION_TYPE.CREATE}_${ObjectCategory.TEAM}`,
    CreateTeams: `${ACTION_TYPE.CREATE}_${ObjectCategory.TEAM}S`,
    EditTeams: `${ACTION_TYPE.EDIT}_${ObjectCategory.TEAM}S`,
    DeleteTeams: `${ACTION_TYPE.DELETE}_${ObjectCategory.TEAM}S`,
    ArchiveTeams: `${ACTION_TYPE.ARCHIVE}_${ObjectCategory.TEAM}S`,
    RestoreTeams: `${ACTION_TYPE.RESTORE}_${ObjectCategory.TEAM}S`,
    AssignMobileUsersToTeam: `${ACTION_TYPE.ASSIGN_MOBILE_USERS_TO}_${ObjectCategory.TEAM}`,
    AssignWebUsersToTeam: `${ACTION_TYPE.ASSIGN_WEB_USERS_TO}_${ObjectCategory.TEAM}`,
    // transformation management
    FetchTransformations: `${ACTION_TYPE.FETCH}_${ObjectCategory.TRANSFORMATION}S`,
    CreateTransformation: `${ACTION_TYPE.CREATE}_${ObjectCategory.TRANSFORMATION}`,
    DeleteTransformation: `${ACTION_TYPE.DELETE}_${ObjectCategory.TRANSFORMATION}`,
    EditTransformation: `${ACTION_TYPE.EDIT}_${ObjectCategory.TRANSFORMATION}`,
    // stream management
    FetchStreams: `${ACTION_TYPE.FETCH}_${ObjectCategory.STREAM}S`,
    CreateStream: `${ACTION_TYPE.CREATE}_${ObjectCategory.STREAM}`,
    DeleteStream: `${ACTION_TYPE.DELETE}_${ObjectCategory.STREAM}`,
    EditStream: `${ACTION_TYPE.EDIT}_${ObjectCategory.STREAM}`,
    UseStream: `${ACTION_TYPE.RUN}_${ObjectCategory.STREAM}`,
    // emailgeneration management
    FetchEmailGenerations: `${ACTION_TYPE.FETCH}_${ObjectCategory.EMAILGENERATION}S`,
    CreateEmailGeneration: `${ACTION_TYPE.CREATE}_${ObjectCategory.EMAILGENERATION}`,
    DeleteEmailGeneration: `${ACTION_TYPE.DELETE}_${ObjectCategory.EMAILGENERATION}`,
    EditEmailGeneration: `${ACTION_TYPE.EDIT}_${ObjectCategory.EMAILGENERATION}`,
    UnsubscribeEmailGenerations: "UNSUBSCRIBE",
    SendWebhookCallbacksData: "SEND_WEBHOOK_CALLBACK_DATA",
    // client management
    FetchClient: `${ACTION_TYPE.FETCH}_${ObjectCategory.CLIENT}`,
    FetchClients: `${ACTION_TYPE.FETCH}_${ObjectCategory.CLIENT}S`,
    CreateClient: `${ACTION_TYPE.CREATE}_${ObjectCategory.CLIENT}`,
    ArchiveClient: `${ACTION_TYPE.ARCHIVE}_${ObjectCategory.CLIENT}`,
    RestoreClient: `${ACTION_TYPE.RESTORE}_${ObjectCategory.CLIENT}`,
    DeleteClient: `${ACTION_TYPE.DELETE}_${ObjectCategory.CLIENT}`,
    EditClient: `${ACTION_TYPE.EDIT}_${ObjectCategory.CLIENT}`,
    EditTeamsHierarchy: `${ACTION_TYPE.EDIT}_${ObjectCategory.TEAM}S_HIERARCHY`,
    UploadClientPicture: "UPLOAD_CLIENT_PICTURE",
    GetLicenseStatus: "GET_LICENSE_STATUS",
    ExportClientData: "EXPORT_CLIENT_DATA",
    FetchDbUser: `${ACTION_TYPE.FETCH}_DB_USER`,
    GoLive: `GO_LIVE`,
    ViewStripeClientPortal: `VIEW_BILLING_CLIENT_STRIPE_PORTAL`,
    FetchOwners: `${ACTION_TYPE.FETCH}_OWNERS`,
    // dashboard management
    FetchDashboard: `${ACTION_TYPE.FETCH}_${ObjectCategory.DASHBOARD}`,
    FetchDashboards: `${ACTION_TYPE.FETCH}_${ObjectCategory.DASHBOARD}S`,
    ArchiveDashboards: `${ACTION_TYPE.ARCHIVE}_${ObjectCategory.DASHBOARD}S`,
    RestoreDashboards: `${ACTION_TYPE.RESTORE}_${ObjectCategory.DASHBOARD}S`,
    CreateDashboard: `${ACTION_TYPE.CREATE}_${ObjectCategory.DASHBOARD}`,
    DeleteDashboard: `${ACTION_TYPE.DELETE}_${ObjectCategory.DASHBOARD}`,
    ComputeDashboard: `${ACTION_TYPE.RUN}_${ObjectCategory.DASHBOARD}`,
    EditDashboard: `${ACTION_TYPE.EDIT}_${ObjectCategory.DASHBOARD}`,
    ComputeDefaultDashboard: `${ACTION_TYPE.RUN}_DEFAULT_DASHBOARD`,
    GetUserReport: `GET_USER_REPORT`,
    GetRecapReport: `GET_RECAP_REPORT`,
    // uploads
    GetClientPictures: `${ACTION_TYPE.FETCH}_${ObjectCategory.CLIENT}_PICTURES`,
    UploadFiles: `UPLOAD_FILES`,
    // documents
    GetDocuments: `${ACTION_TYPE.FETCH}_${ObjectCategory.DOCUMENT}S`,
    CreateDocument: `${ACTION_TYPE.CREATE}_${ObjectCategory.DOCUMENT}`,
    EditDocument: `${ACTION_TYPE.EDIT}_${ObjectCategory.DOCUMENT}`,
    DeleteDocument: `${ACTION_TYPE.DELETE}_${ObjectCategory.DOCUMENT}`,
    // logs
    FetchLogs: `${ACTION_TYPE.FETCH}_${ObjectCategory.LOG}S`,
    // GPS recording
    RecordUserLocations: "RECORD_USER_LOCATION",
    // profile
    EditProfile: "EDIT_PROFILE",
    UploadProfilePicture: `UPLOAD_PROFILE_PICTURE`,
    // Postgres
    RestorePostgres: "RESTORE_POSTGRES",
    RestorePostgresLight: "RESTORE_POSTGRES_LIGHT",
    ForceNewSubmissions: "FORCE_NEW_SUBMISSIONS",
    RestoreWorkflowInPostgres: "RESTORE_WORKFLOW_IN_POSTGRES",
    RestoreListInPostgres: "RESTORE_LIST_IN_POSTGRES",
    RestorePostgresForClient: "RESTORE_POSTGRES_FOR_CLIENT",
    AddColumnToTable: "ADD_COLUMN_TO_TABLE",
    DropColumnToTable: "DROP_COLUMN_TO_TABLE",
    AddTable: "ADD_TABLE",
    ExtractData: "EXTRACT_DATA",
    GetDbSchema: "GET_DB_SCHEMA",
    FakeSubmitter: "FAKE_SUBMITTER",
    GetSharedFile: "GET_SHARED_FILE",
    // Table Optimization
    GetTableOptimizations: `${ACTION_TYPE.FETCH}_TABLE_OPTIMIZATIONS`,
    CreateTableOptimization: `${ACTION_TYPE.CREATE}_TABLE_OPTIMIZATION`,
    DeleteTableOptimization: `${ACTION_TYPE.DELETE}_TABLE_OPTIMIZATION`,
    // Other
    LogError: "LOG_ERROR",
    GetDeltaFirestorePostgres: "GET_DELTA_FIRESTORE_POSTGRES",
    CleanupFirestoreGcsUrls: "CLEANUP_FIRESTORE_GCS_URLS",
    OtherAction: "OTHER_ACTION",
    CheckWebAppUpdate: "CHECK_WEB_APP_UPDATE",
    DuplicateClient: "DUPLICATE_CLIENT",
};
const getActionNotLogged = () => {
    const result = [];
    for (let act in exports.ACTION_CODE) {
        if (exports.ACTION_CODE[act].startsWith(ACTION_TYPE.FETCH)) {
            result.push(exports.ACTION_CODE[act]);
        }
    }
    result.push(exports.ACTION_CODE.RECORD_USER_LOCATION);
    return result;
};
exports.getActionNotLogged = getActionNotLogged;
const isActionToBeLogged = (action) => {
    if (exports.getActionNotLogged().includes(action)) {
        return false;
    }
    else {
        let result = false;
        Object.keys(exports.ACTION_CODE).forEach((act) => {
            if (exports.ACTION_CODE[act] === action) {
                result = true;
            }
        });
        return result;
    }
};
exports.isActionToBeLogged = isActionToBeLogged;
